
// 인증서 관리
// 사설 인증기관 설정
//
// @since 2018-03-26
// @author 강정규 ( devp012 )

export const state = () => ({
  urlConfig: '/api/sm/cert-private',
  urlInfo: '/api/sm/cert-private/cert',
  configData: {
    use: 0, //            required (one of 0, 1) 사용(OFF: 0, ON: 1)
    passwd: '', //        (string - minLength: 9 - maxLength: 32) 인증 비밀번호,Base64로 인코딩하여 전달한다.
    //                    9자 이상, 32자 이하의 영문/숫자/특수문자 조합
    //                    Well-known Word(admin,administrator,test,qwe,user) 사용 불가
    effective_days: 1, // required (integer - default: 365 - minimum: 1 - maximum: 36500) 인증서 유효 기간(일)
    cert_bit: 512 //      required (one of 512, 1024, 2048 - default: 512) 인증서 비트수

    // enable: true, //   required (boolean) 사용
    // expire_days: '', // required (integer - default: 365 - minimum: 1 - maximum: 36500) 인증서 유효 기간(일)
    // bit: '', //         required (one of 512, 1024, 2048) 인증서 비트수
    // password: '' //     (string - minLength: 9 - maxLength: 32) 인증 비밀번호,Base64로 인코딩하여 전달한다.
    //                  9자 이상, 32자 이하의 영문/숫자/특수문자 조합 Well-known Word(admin,administrator,test,qwe,user) 사용 불가
  },
  infoData: [],
  infoDataKey: [
    {key: 'sign_algr', name: '서명 알고리즘'}, //    required (string) 서명 알고리즘
    {key: 'issuer', name: '발급자'}, //              required (string) 발급자
    {key: 'start_date', name: '유효 기간(시작)'}, // required (string) 유효 기간(시작)
    {key: 'end_date', name: '유효 기간(끝)'}, //     required (string) 유효 기간(끝)
    {key: 'subject', name: '주제'}, //               required (string) 주제
    {key: 'public_algr', name: '공개키 알고리즘'} // required (string) 공개키 알고리즘
  ],
  dialogData: {
    cert_name: '', //         required (string - maxLength: 32) 인증서 ID
    country: 'KR', //         required (one of KR, US, JP, CN) 국가 코드 (대한민국: KR, 미국: US, 일본: JP, 중국: CN)
    state: '', //             required (string - maxLength: 32) 주/도
    location: '', //          required (string - maxLength: 32) 도시
    organization: '', //      required (string - maxLength: 32) 조직
    organization_unit: '', // required (string - maxLength: 32) 부서
    common_name: '', //       required (string - maxLength: 32) 별칭
    email: '' //              required (string - maxLength: 32) 메일 주소
  }
})

export const mutations = {
  // 인증 서버 설정 정보 조회
  getCertPrivateConfig: (state, data) => {
    state.configData = data
  },
  // 인증서 파일 조회
  getCertPrivateInfo: (state, data) => {
    const rowDataList = []
    for (const item of state.infoDataKey) {
      rowDataList.push({name: item.name, desc: data[item.key]})
    }
    state.infoData = rowDataList
  },
  // 인증서 파일 설정 (발급)
  setCertPrivateInfo: (state, data) => {
    state.infoData = data
  },
  clearCertPrivateDialogInfo: (state) => {
    state.dialogData.cert_name = ''
    state.country = 'KR'
    state.state = ''
    state.location = ''
    state.organization = ''
    state.organization_unit = ''
    state.common_name = ''
    state.email = ''
  }
}

export const actions = {
  // 인증 서버 설정 정보 조회
  async getCertPrivateConfig ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.urlConfig)
    if (code === 'ok') {
      commit('getCertPrivateConfig', result)
      return true
    }
    return false
  },
  // 인증 서버 설정
  async setCertPrivateConfig ({commit, state}, password) {
    if (password === '') {
      delete state.configData.passwd
    } else {
      state.configData.passwd = btoa(password)
    }
    const {code, result} = await this.$axios.$put(state.urlConfig, state.configData)

    if (code === 'ok') {
      commit('getCertPrivateConfig', result)
      return true
    }
    return false
  },
  async finalCommand ({commit, state}, type) {
    let param = {}
    if (type === 'apply') {
      param = { applyMsg: true }
    } else {
      param = { cancelMsg: true }
    }
    const {code} = await this.$axios.$put(`${state.urlConfig}/${type}`, null, param)
    if (code === 'ok') {
      return true
    }
    return false
  },

  // 인증서 파일 조회
  async getCertPrivateInfo ({commit, state}) {
    const {code, result} = await this.$axios.$get(state.urlInfo)
    if (code === 'ok') {
      commit('getCertPrivateInfo', result)
      return true
    }
    return false
  },
  // 인증서 파일 설정
  async setCertPrivateInfo ({commit, state}, param) {
    const {code, result} = await this.$axios.$post(state.urlInfo, state.dialogData, param)
    if (code === 'ok') {
      commit('getCertPrivateInfo', result)
      return true
    }
    return false
  }
}

export const getters = {
  getTest () {
    return 1
  }
}

export const strict = false
